export default "__VITE_ASSET__RdAgjTmM__"